/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Polish (Poland)
export default {
  'embedded-confluence-common.src.content.empty-state-description':
    'Szukaliśmy tej strony wszędzie, ale nigdzie jej nie ma. Możliwe, że została usunięta. O ile, oczywiście, do adresu URL nie wkradła się literówka 😉',
  'embedded-confluence-common.src.content.empty-state-header': 'Nie można znaleźć tego, czego szukasz',
  'embedded.confluence.already-logged-in-paragraph': 'Już przeprowadzono logowanie? Spróbuj odświeżyć.',
  'embedded.confluence.footer.hover.text': 'Wyświetl w Confluence',
  'embedded.confluence.footer.prefix': 'Obsługiwane przez',
  'embedded.confluence.generic-error-page.login-to-confluence-button': 'Zaloguj się w Confluence',
  'embedded.confluence.login-page.login-button': 'Zaloguj się w systemie Confluence',
  'embedded.confluence.login-page.login-button.aria-label': 'Przycisk logowania',
  'embedded.confluence.login-page.login-text': 'Musisz się zalogować, aby wyświetlić tę stronę.',
  'embedded.confluence.login-page.refresh-page-banner':
    'Po zalogowaniu ta strona powinna odświeżyć się automatycznie. Jeśli tak się nie stanie, kliknij tutaj, aby odświeżyć.',
  'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Odśwież stronę',
  'embedded.confluence.need-to-log-in-paragraph': 'Musisz się zalogować, aby wyświetlić tę stronę.',
  'embedded.confluence.still-having-trouble-paragraph':
    'Nadal masz problem? Upewnij się, że obsługa plików cookie innych firm jest włączona lub {link}.',
  'embedded.confluence.troubleshooting-link-text': 'zapoznaj się z tym przewodnikiem rozwiązywania problemów',
  'embedded.confluence.troubleshooting-link.aria-label': 'łącze do przewodnika rozwiązywania problemów',
};
